import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { Typography } from '../../Typography';

var rootStyle = function rootStyle(_ref) {
  var isFixed = _ref.isFixed;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), isFixed ? 'overflow-y: auto;' : '');
};

export var SideSheetBodyRoot = styled(Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: inline-block;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    margin: 0;\n\n    ", ";\n"])), rootStyle);